import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { LoaderService } from '../../shared/loader.service';
import { ToastService } from '../../shared/toast.service';

@Component({
  selector: 'app-gold-page',
  templateUrl: './gold-page.component.html',
  styleUrls: ['./gold-page.component.scss']
})
export class GoldPageComponent {
  goldCards = [
    {
      img: '../../../assets/goldpage/cards/1.png',
      head: 'One-Year Membership to NexGen Executive Coaching Academy state-of-the-art LMS platform, featuring:',
      para: 'Interactive training modules',
      para2: 'Quizzes',
      para3: 'Patented AI-driven coaching frameworks',
    },
    {
      img: '../../../assets/goldpage/cards/2.png',
      head: 'On-Demand Learning',
      para: 'Pre-recorded Executive Coaching video content'
    },
    {
      img: '../../../assets/goldpage/cards/3.png',
      head: 'Downloadable Rich Content',
      para: 'Over 1,000 real-world PDFs, PowerPoints, and training documents covering coaching models, frameworks, case studies, and best practices'
    },
    {
      img: '../../../assets/goldpage/cards/4.png',
      head: 'Customizable AI Co-Pilot Coach Assistant',
      para: 'Includes the patented NexGen Executive Coaching Academy app for mobile (Android/iOS)'
    }
  ];

  isLoading = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private toastService: ToastService,
  ) {}

  goToBilling(): void {
    if (this.isLoading) return;

    this.isLoading = true;
    this.loaderService.show();

    this.commonService.getPackages().subscribe({
      next: (response: any) => {
        if (response.status === 1 && Array.isArray(response.data)) {
          // 🔑 Use includes() instead of strict equality
          const goldPkg = response.data.find(
            (p: any) => p.name?.toLowerCase().includes('gold')
          );

          if (!goldPkg) {
            console.error('Gold package not found in API response', response.data);
            this.toastService.showError('Gold package is not available right now.');
            this.finishLoading();
            return;
          }

          // 👇 Same price logic as PackageSelectionComponent
          const priceDisplay =
            goldPkg.price === 0 ? 'Custom Pricing' : `$${goldPkg.price}`;

          this.router.navigate(['/billing-form'], {
            queryParams: {
              packageId: goldPkg._id,
              package: goldPkg.name,
              price: priceDisplay,
              installment: goldPkg.installmentExist === true
            }
          });
        } else {
          console.error('Unexpected packages response', response);
          this.toastService.showError('Failed to load packages. Please try again.');
        }

        this.finishLoading();
      },
      error: (err) => {
        console.error('Failed to load packages', err);
        this.toastService.showError('Failed to load packages. Please try again.');
        this.finishLoading();
      }
    });
  }

  private finishLoading(): void {
    this.isLoading = false;
    this.loaderService.hide();
  }
}
